import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useTrackPreviousPath = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;

    if (!path.startsWith('/candidate')) {
      sessionStorage.setItem('prevCandidateListPath', path);
    }
  }, [location]);
};

export default useTrackPreviousPath;